import { render, staticRenderFns } from "./DialogAsistente.vue?vue&type=template&id=3e10d5ce&"
import script from "./DialogAsistente.vue?vue&type=script&lang=js&"
export * from "./DialogAsistente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports